module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-2.ab86b276.svg";